export const currency = 'INR';
